// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueI18n from 'vue-i18n';
// import VueAnalytics from 'vue-analytics';
import firebase from 'firebase/compat/app';
import VueMeta from 'vue-meta';
import { firebaseConfig } from './config/firebase';

import Vuetify from 'vuetify';
import VueClipboard from 'vue-clipboard2';
import localeService from '@/services/localeService';
import axiosInterceptors from './config/axiosInterceptors';
import i18nFilter from '@/filters/i18nFilter';
import VueWaypoint from 'vue-waypoint';
import '@mdi/font/css/materialdesignicons.css';
import './assets/stylus/main.styl';
import sessionService from './services/sessionService';
import CircularCountDownTimer from 'vue-circular-count-down-timer';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import {
  faXTwitter,
  faYoutube,
  faFacebook,
  faLinkedinIn,
  faInstagram,
  faAndroid,
  faApple,
} from '@fortawesome/free-brands-svg-icons';

/* add icons to the library */
library.add(
  faXTwitter,
  faYoutube,
  faFacebook,
  faLinkedinIn,
  faInstagram,
  faAndroid,
  faApple
);

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon);

axiosInterceptors.init();
i18nFilter.init();

Vue.use(VueWaypoint);
Vue.use(VueMeta);
Vue.use(VueI18n);
Vue.use(Vuetify, {
  theme: {
    primary: '#5ea4c8',
    secondary: '#88C1DF',
    accent: '#da9500',
    info: '#4FC3F7',
    success: '#81C784',
    warning: '#FFB74D',
    error: '#EF5350',

    bookingRemoved: '#BDBDBD',
    bookingReubicationCancelled: '#F44336',
    bookingPreSubscription: '#EA80FC',
    bookingSubscription: '#00BCD4',
    bookingSystem: '#263238',
    bookingPaid: '#a1bc31',
    bookingAccepted: '#5ea4c8',
    bookingInUse: '#da9500',

    fundsDEPOSIT_BUY: '#da9500',
    fundsDEPOSIT_PROMO: '#da9500',
    fundsDEPOSIT_PROMO_FREE: '#da9500',
    fundsDEPOSIT_HOSTESS: '#5ea4c8',
    fundsDEPOSIT_SIMPLE_REGISTER: '#5ea4c8',
    fundsDEPOSIT_FULL_REGISTER: '#5ea4c8',
    fundsDEPOSIT_TRANSFER: '#da9500',
    fundsDEPOSIT_CASH: '#da9500',
    fundsDEPOSIT_REGISTER: '#5ea4c8',
    fundsWITHDRAWAL_USE: '#a1bc31',
    fundsWITHDRAWAL_ITEM: '#a1bc31',
    fundsREFUND_ITEM: '#da9500',
    fundsBALANCE_EXPIRED: '#da9500',
    fundsROLLBACK_TRANFER: '#a1bc31',
    fundsUNSUBSCRIBE: '#BDBDBD',
    fundsAWARD_GODFATHER: '#5ea4c8',
    fundsREFUND: '#EA80FC',
    fundsUNLIMITED: '#EA80FC',
    fundsCANCEL_UNLIMITED: '#EA80FC',
    fundsTEST: '#EA80FC',
    fundsMERGE: '#EA80FC',
    fundsSHARE_FACEBOOK: '#5ea4c8',
    fundsWITHDRAWAL_SUBSCRIPTION_OLD: '#00BCD4',
    fundsWITHDRAWAL_SUBSCRIPTION_NIGHT: '#00BCD4',
    fundsWITHDRAWAL_SUBSCRIPTION_DAY: '#00BCD4',
    fundsWITHDRAWAL_SUBSCRIPTION_WEEK: '#00BCD4',
    fundsWITHDRAWAL_SUBSCRIPTION_MONTH: '#00BCD4',
    fundsWITHDRAWAL_SUBSCRIPTION_CUSTOM: '#00BCD4',
    fundsWITHDRAWAL_SUBSCRIPTION_MULTI: '#00BCD4',
  },
});

Vue.config.productionTip = false;

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.use(CircularCountDownTimer);

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

let start = (store) => {
  let defaultLangSelected = store.state.langSelected;
  // let defaultLangSelected = oLocalStorage.get('langSelected') !== null ? oLocalStorage.get('langSelected') : config.LANGUAGES['en-GB'];

  // if (defaultLangSelected === null) {
  //   defaultLangSelected = config.LANGUAGES['en-GB'];
  // } else {
  //   defaultLangSelected = config.LANGUAGES[defaultLangSelected.langIso];
  // }

  // let defaultCountrySelected = oLocalStorage.get('countryConstantsSelected');

  // if (defaultCountrySelected === null) {
  //   localeService.changeCountryLanguage('es');
  // }

  let messages = {
    'ca-ES': require('./locales/messages_ca-ES.json'),
    'en-GB': require('./locales/messages_en-GB.json'),
    'es-ES': require('./locales/messages_es-ES.json'),
    'es-CL': require('./locales/messages_es-CL.json'),
  };

  const i18n = new VueI18n({
    locale: defaultLangSelected.langIso,
    messages,
  });

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    i18n,
    template: '<App/>',
    async created() {
      firebase.initializeApp(firebaseConfig);
      if (store.state.isLogged) {
        await sessionService.check(false);
      }
      // firebase.auth().useDeviceLanguage();
    },
    components: {
      App,
    },
    render: (h) => h(App),
    mounted() {
      // You'll need this for renderAfterDocumentEvent.
      document.dispatchEvent(new Event('render-event'));
    },
  });
};

localeService.getCityByUrl(start);

console.log(
  '                _____                      _                    _    '
);
console.log(
  '               / ____|                    | |                  | |   '
);
console.log(
  ' __      _____| (___  _ __ ___   __ _ _ __| |_ _ __   __ _ _ __| | __'
);
console.log(
  " \\ \\ /\\ / / _ \\\\___ \\| '_ ` _ \\ / _` | '__| __| '_ \\ / _` | '__| |/ /"
);
console.log(
  '  \\ V  V /  __/____) | | | | | | (_| | |  | |_| |_) | (_| | |  |   < '
);
console.log(
  '   \\_/\\_/ \\___|_____/|_| |_| |_|\\__,_|_|   \\__| .__/ \\__,_|_|  |_|\\_\\'
);
console.log(
  '                                              | |                    '
);
console.log(
  '                                              |_|                    '
);
console.log(
  `v ${JSON.stringify(require('@/../package.json').version)
    .replace('"', '')
    .replace('"', '')}`
);
